import formatDuration from './format-duration';

export { formatDuration };

export default formatDuration;
